module.exports = __webpack_public_path__ + "media/images/badge/ninja-f9b6f1467edbe4bfbd45c7c3155e7e1b.png";